import { action as apiAction } from 'api/Api'
import {
  set as setElement,
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number;
  documentFolderCreatorId: number;
  documentSourceId: number;
  path?: string;
}

const requestChangeDocumentFolderCreatorPath = (payload: Payload) => async dispatch => {
  const { cardId, documentFolderCreatorId, documentSourceId, path } = payload

  const optimisticAction = optimisticDispatch(dispatch, setElement({
    cardId,
    element: {
      id: documentFolderCreatorId,
      documentSourceId,
      path,
    }
  }))

  try {
    await apiAction('ChangeDocumentsFolderCreatorPath', {
      documentsFolderCreatorId: documentFolderCreatorId,
      documentSourceId,
      path,
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestChangeDocumentFolderCreatorPath